<script setup>
import {defineProps} from 'vue'
const props = defineProps({
  bg: {
    type: String,
    default: "",
  },
  image: {
    type: String,
    default: "https://storageasklepia.b-cdn.net/image.svg",
  },
  classess: {
    type: String,
    default: "bg-gray-100 dark:bg-gray-800",
  }
});
const url = "https://storageasklepia.b-cdn.net/image.svg";
</script>

<template>
  <div>
    <img :src="props.image || url" alt="image" class="block max-w-full hover:bg-green-100 bg-gray-100 dark:bg-green-100"
      :class="classess" />
  </div>
</template>
